export class PollModel {
	constructor(id, clientId, title) {
		[this.id, this.clientId, this.title] = [id, clientId, title];
		this.listeners = [];
		this.questions = [];
	}
	static DefaultModel(id=0, clientId=0) {
		const pm = new PollModel(id, clientId, ``);
		const qm = pm.addQuestion(0, 0, `single`, ``);
		qm.addOption(1,1,``);
		qm.addOption(2,2,``);
		return pm;
	}
	addListener(l) { this.listeners.push(l); }
	removeListener(l) { this.listeners = this.listeners.filter (c=>l!=c) }
	setPoll(title) {
		this.title = title;
		this.listeners.map(l => l.poll_changed(this));
	}
	addQuestion(id, num, qtype, text) {
		const qm = new QuestionModel(id, num, qtype, text);
		qm.addListener(this);
		this.questions.push(qm);
		this.listeners.map(l => l.question_added(qm));
		return qm;
	}
	removeQuestion(qm) {
		this.listeners.map(l => l.question_removed(qm));
		qm.removeListener(this);
	}
	option_added(om) { this.listeners.map(l => l.poll_changed(this)); }
	option_changed(om) { this.listeners.map(l => l.poll_changed(this)); }
	option_removed(om) { this.listeners.map(l => l.poll_changed(this)); }
	object() {
		return {
			ID: this.id,
			ClientID: this.clientId,
			Revision: this.revision,
			Title: this.title,
			Questions: this.questions.map( q=>q.object() )
		};
	}
	fromObject(o) {
		console.log(`Setting PollModel fromObject: `, o);
		this.id = o.ID;
		this.clientId = o.ClientID;
		this.revision = o.Revision;
		this.title = o.Title;
		o.Questions.map(q => {
			const qm = this.addQuestion(q.ID, q.Number, q.Qtype, q.Question);
			q.Options.map( o=>{
				qm.addOption(o.ID, o.Number, o.Option);
			});
		});
	}
	updateFromSaved(js) {
		console.log(`Updating model from saved. PollID = ${js.ID}`);
		this.id = js.ID;
		this.clientId = js.ClientID;
		this.revision = js.Revision;
		for (const qi in this.questions) {
			const qm = this.questions[qi];
			const jm = js.Questions[qi];
			//this.removeQuestion(qm);
			qm.id = jm.ID;
			for(const oi in qm.options){
				const om = qm.options[oi];
				const jo = jm.Options[oi];
				om.id = jo.ID;
			}
		}
	}
	
	question_removed(qm) {
		this.questions = this.questions.filter( q => q!=qm );
		qm.removeListener(this);
		this.listeners.map(l => l.poll_changed(this) );
	}
	question_changed(qm) {
		this.listeners.map(l => l.poll_changed(this) );
	}
}

export class QuestionModel {
	constructor(id, num, qtype, text) {
		[this.id, this.num, this.qtype, this.text] = [id, num, qtype, text];
		this.listeners = [];
		this.options = [];
	}
	addListener(l) { this.listeners.push(l); }
	removeListener(l) { this.listeners = this.listeners.filter (c=>l!=c) }
	addOption(id, num, text) {
		let om = new OptionModel(id, num, text);
		om.addListener(this);
		this.options.push(om);
		this.listeners.map(l => l.option_added(om));
	}
	isSingleSelectType() {
		return this.qtype==`single`;
	}
	isMultiSelectType() {
		return this.qtype==`multi`;
	}
	isTextType() {
		return this.qtype==`text`;
	}
	setModelText(txt) {
		this.text = txt;
		this.listeners.map(l=>l.question_changed(this));
	}
	setModelQuestionType(qt) {
		this.qtype = qt;
		this.listeners.map(l=>l.question_changed(this));
		console.log(`question_type = ${qt}`);
	}
	// callback from OptionModel on change
	option_changed(om) {
		this.listeners.map(l=>l.option_changed(om));
	}
	// callback from OptionModel on removal
	option_removed(om) {
		this.options = this.options.filter(c=>c!=om);
		this.listeners.map(l => l.option_removed(om));
	}
	remove() {
		this.listeners.map(l => l.question_removed(this));
	}
	object() {
		return {
			ID: this.id,
			Number: this.num,
			Qtype: this.qtype, 
			Question: this.text,
			Options: this.options.map(o=>o.object())
		}
	}
}

export class OptionModel {
	constructor(id, num, text) {
		[this.id, this.num, this.text] = [id,num,text];
		this.listeners = [];
	}
	addListener(l) { this.listeners.push(l); }
	removeListener(l) { this.listeners = this.listeners.filter (c=>l!=c) }
	setOption(num, text) {
		this.number = num;
		this.text = text;
		this.listeners.map(l => l.option_changed(this));		
	}
	remove() {
		this.listeners.map(l => l.option_removed(this));
	}
	object() {
		return {
			ID: this.id,
			Number: this.num,
			Option: this.text
		}
	}
}
